import { makeStyles } from "tss-react/mui";
import { DialogTitle, DialogContent, DialogActions, Typography, Button } from "@mui/material";
import themeCfg from "config/theme.json";
import { Warning, Info, Error } from "@mui/icons-material";
import { Logo } from "constants/ui";

const useStyles = makeStyles()((theme: any) => ({
    root: {
        width: "100%",
        maxWidth: "max-content",
        backgroundColor: theme.palette.background.paper,
        borderRadius: 4,
    },
    paper: {
        width: "80%",
        maxHeight: 435,
    },
    title: {
        padding: "3px 24px",
    },
    content: {
        padding: "40px 24px",
        width: 360,
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
}));

type IProps = {
    notification: any;
    handleClose: () => void;
};

export default function AlertDialog(props: IProps) {
    const { classes } = useStyles();
    const { notification } = props;
    const { message, type } = notification;
    const checkType = () => {
        switch (type) {
            case "info":
                return <Info style={{ color: "#218aff" }} />;
            case "warning":
                return <Warning style={{ color: "#ffcc00" }} />;
            case "error":
                return <Error style={{ color: "red" }} />;
            default:
                return "";
        }
    };
    const handleClose = () => {
        if (notification["callback"]) {
            notification["callback"]();
        }
        props.handleClose();
    };
    return (
        <div
            style={{
                position: "fixed",
                zIndex: 1300,
                inset: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
            }}
        >
            <div
                style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <div className={classes.root}>
                    <DialogTitle style={{ padding: 10 }}>
                        <img src={Logo} alt={themeCfg.logoTitle} style={{ display: "block", width: 150 }} />
                    </DialogTitle>
                    <DialogContent style={{ padding: 20 }}>
                        <div style={{ display: "inline-flex", alignItems: "center" }}>
                            {checkType()}
                            <Typography style={{ marginLeft: 10 }} noWrap>
                                {message}
                            </Typography>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="primary">
                            OK
                        </Button>
                    </DialogActions>
                </div>
            </div>
        </div>
    );
}
